module.exports = __webpack_public_path__ + "static/media/pickup_pass.6b86831d.svg";